import { render, staticRenderFns } from "./AccettazioneSsnSchedaPazientePage.vue?vue&type=template&id=2d281afa&scoped=true"
import script from "./AccettazioneSsnSchedaPazientePage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnSchedaPazientePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d281afa",
  null
  
)

export default component.exports